import './NewsArticleTitle.scss';
import { Heading } from '@lmig/lmds-react-typography';
import { useContext, useEffect, useState } from 'react';
import { IconButton, IconDocumentMulti } from '@lmig/lmds-react-icons';
import { formatDateMonthDDYYYY } from 'Utilities/StringFormatter';
import { INewsArticleContext, NewsArticleContext } from './NewsArticleContext';

interface NewsArticleTitleProps {
  ItemGuid: string;
}

export function NewsArticleTitle(props?: NewsArticleTitleProps) {
  const [formattedDate, setFormattedDate] = useState<string>('');
  const articleContext = useContext<INewsArticleContext>(NewsArticleContext);

  useEffect(() => {
    if (props?.ItemGuid) articleContext.setArticleId(props?.ItemGuid);
  }, [articleContext, props?.ItemGuid]);

  useEffect(() => {
    if (articleContext?.article?.PublishDate) {
      setFormattedDate(formatDateMonthDDYYYY(articleContext.article.PublishDate));
    }
  }, [articleContext?.article?.PublishDate]);

  return (
    <>
      {props && (
        <div className="news-title-container">
          <IconButton background="transparent" disabled>
            <IconDocumentMulti size="32" />
          </IconButton>
          <Heading type="h4" className="publish-date">
            News {formattedDate && <>| {formattedDate}</>}
          </Heading>
        </div>
      )}
    </>
  );
}

export default NewsArticleTitle;
